import { call, put } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { loadFileByUrlFailed, loadFileByUrlSuccessful } from '../actions';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import processError from '../../../utils/processError';

export default function* loadFileByUrl(action) {
  try {
    const link = action.payload;
    const pool = {};
    const dataResponse = yield makeRequest(link, pool, action, 'GET');
    if (dataResponse.status === OK) {
      const data = yield dataResponse.blob();
      const header = dataResponse.headers.get('content-disposition');
      debugger;
      let filename = 'downloaded_file.json';
      if (header && header.includes('filename=')) {
        const matches = header.match(/filename\*=UTF-8''(.+)|filename="?(.+?)"?$/);
        if (matches) {
          filename = decodeURIComponent(matches[1] || matches[2]);
        }
      }
      data.filename = filename;
      yield put(loadFileByUrlSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadFileByUrlFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadFileByUrlFailed([]));
    yield call(rejectActionPromise(action, {}));
    yield processError(e);
  }
}
